import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerTriggerElement } from "@design-system/Picker/Picker.types";

export const createActionSectionTrigger = (
    className?: string,
): PickerTriggerElement => (
    <Picker.Button variant="primary" className={className} />
);
